import {
  SHOW_RESTRICTIONS_MODAL,
  SHOW_RESTRICTIONS_MODAL_HIDE,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  openModal: false,
  restrictions: [],
  settings: null,
  model2: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SHOW_RESTRICTIONS_MODAL:
      return { ...state, openModal: true, restrictions: action.payload.data, settings: action.payload.settings, model2: action.payload.model2 || false };

    case SHOW_RESTRICTIONS_MODAL_HIDE:
      return { ...state, openModal: false, restrictions: [], settings: null };

    case CLEAR_REDUX:
      return ["", "RESTRICTIONS_MODAL"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }

    default:
      return state;
  }
};
